import { UploadOutlined } from '@ant-design/icons';
import { Button, fetch, message, Modal } from '@maxtropy/components';
import { Space, Upload } from 'antd';
import { RcFile } from 'antd/es/upload';
import { useState } from 'react';
import { BaselineDataRecord } from './types';

interface BaselineDataModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: (values: BaselineDataRecord[]) => void;
}

const downloadUrl = '/api/v2/microgrid/topology/baseline-data/template/download';

const BaselineDataModal = (props: BaselineDataModalProps) => {
  const { open, onCancel, onOk } = props;
  const [fileList, setFileList] = useState<RcFile[]>([]);
  const [uploading, setUploading] = useState(false);

  const handleDownload = () => {
    window.open(downloadUrl, '_blank');
  };

  const handleOk = async () => {
    if (!fileList.length) {
      message.warning('请选择文件');
      return;
    }

    const formData = new FormData();
    formData.append('file', fileList[0]);
    setUploading(true);

    const result = await fetch<{ list?: BaselineDataRecord[] }>(
      '/api/v2/microgrid/topology/baseline-data/excel-to-json',
      {
        method: 'POST',
        body: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      },
      true
    )
      .then(res => res.list ?? [])
      .finally(() => setUploading(false));

    onOk(result);
    setFileList([]);
    message.success('上传成功');
  };

  return (
    <Modal
      title="导入基准数据"
      open={open}
      width={560}
      contentClassName="modal-form-content"
      destroyOnClose
      confirmLoading={uploading}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <div>
        <Button type="link" htmlType="button" onClick={handleDownload}>
          下载已导入数据
        </Button>
        <Space size={12} align="start" style={{ marginTop: 16 }}>
          <span style={{ color: '#ff4d4f' }}>*</span>
          <span>选择文件：</span>
          <div>
            <Upload
              accept=".xlsx,.xls"
              maxCount={1}
              fileList={fileList}
              beforeUpload={file => {
                const isExcel = /\.(xlsx|xls)$/i.test(file.name);
                const isLt50M = file.size / 1024 / 1024 <= 50;

                if (!isExcel) {
                  message.warning('仅支持 .xlsx、.xls 文件');
                  return Upload.LIST_IGNORE;
                }

                if (!isLt50M) {
                  message.warning('文件不能超过50MB');
                  return Upload.LIST_IGNORE;
                }

                setFileList([file]);
                return false;
              }}
              onRemove={() => {
                setFileList([]);
                return true;
              }}
            >
              <Button htmlType="button" icon={<UploadOutlined />}>
                选择导入文件
              </Button>
            </Upload>
            <div style={{ marginTop: 8, color: 'var(--mx-text-desc-color)', fontSize: 12 }}>
              支持扩展名：.xlsx、.xls，不能超过50MB
            </div>
          </div>
        </Space>
      </div>
    </Modal>
  );
};

export default BaselineDataModal;
